import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {Space} from 'antd';
import {
  StyledDotAmountList,
  StyledDotAmountListItem,
  StyledDotAmountListItemDot,
  StyledDotAmountListItemName,
  StyledDotAmountListItemValue,
} from './StyledDotAmountList';
import ListShowMoreWrapper from '../ListShowMoreWrapper';
import {amountHelpers} from '../../../utils/helpers';

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.35 } },
  exit: { opacity: 0, y: -24, transition: { duration: 0.2 } }
};

const DotAmountList = ({ items, maxVisible = 5, ...rest }) => {
  const [t] = useTranslation('main');
  return (
    <StyledDotAmountList {...rest}>
      <ListShowMoreWrapper
        items={items}
        maxVisible={maxVisible}
        itemVariants={itemVariants}
        renderItem={item => (
          <StyledDotAmountListItemDot color={item.color} />
        )}
        renderContent={({ item }) => (
          <StyledDotAmountListItem style={{ width: '100%' }}>
            <Space size={6} align='center'>
              <StyledDotAmountListItemDot color={item.color} />
              <StyledDotAmountListItemName>{item.name}</StyledDotAmountListItemName>
            </Space>
            <StyledDotAmountListItemValue>{amountHelpers.getAmountWithCurrencyCode(item.value)}</StyledDotAmountListItemValue>
          </StyledDotAmountListItem>
        )}
        itemKey={item => item.name + item.value + item.color}
        itemClass={StyledDotAmountListItem}
        showMoreLabel={t('more')}
      />
    </StyledDotAmountList>
  );
};

DotAmountList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired
    })
  ).isRequired,
  maxVisible: PropTypes.number
};

export default DotAmountList;
